import { useEffect } from "react";
import { useOnDismount } from "./index";


export const useSetWithDismountFallback = (setter, fallbackValue, value) => {
  useEffect(() => {
    setter(() => value);
  }, [setter, value]);

  useOnDismount(() => {
    setter(() => fallbackValue);
  });
};